module.exports = __webpack_public_path__ + "static/img/shop_bj.b52f31e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center/shop_bj.png
// module id = i8zu
// module chunks = 80